import React from "react";
import { useTranslation } from "react-i18next";
import FooterSection from "../components/sections/FooterSection";
import NotificationLegal from "../components/overlays/NotificationLegal";
import YandexMapSection from "../components/sections/YandexMapSection";
import ArticleWithModal from "../components/sections/ArticleWithModal";
import PartnersListScroll from "../components/sections/PartnersListScroll";

function LandingPage(props) {

    var { t } = useTranslation();

    return (
        <div>
            <NotificationLegal />
            <main style={{ position: "relative", overflow: "hidden" }}>

                {/* Background video */}
                <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="auto"
                    style={{
                        position: "fixed",
                        top: "0",
                        left: "0",
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        zIndex: "-1",
                        filter: "blur(0.5px) brightness(0.7)"
                    }}
                >
                    <source src="/imgvideo/kz1.webm" type="video/webm" />
                </video>

                {/* Transparent section */}
                <section className="uk-light uk-flex uk-flex-middle uk-overflow-hidden">
                    <div style={{ height: "92vh" }}
                        className="uk-cover-container uk-width-1-1 uk-height-large">

                        <div className="uk-container uk-position-cover uk-flex uk-flex-middle uk-light">
                            <div className="uk-width-2-3@s">
                                <h4 className="uk-heading-small uk-text-bold uk-text-glow">
                                    {t("infopages.landing.title1")}
                                </h4>
                                <p className="uk-text-lead uk-margin-small-top uk-text-glow">
                                    {t("infopages.landing.title2")}
                                </p>
                                <a
                                    href="/apply-visa"
                                    className="uk-button uk-button-jai uk-margin-top uk-button-large"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {t("infopages.landing.cta1")}
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Opaque UIKit sections */}
                <section
                    className="uk-section-small uk-flex uk-flex-middle no-bg-mobile"
                    style={{
                        backgroundImage: 'url("/kz.svg")',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                    }}
                >
                    <div
                        className="uk-container-expand uk-padding-remove uk-padding-large@l"
                        data-uk-grid=""
                        style={{ paddingLeft: "30vw", paddingRight: "10vw" }}
                    >
                        <div className="uk-width-1-2@s uk-padding-large">
                            <h2 className="uk-heading-medium uk-text-bold uk-margin-remove">
                                {t("infopages.landing.info_h1")}
                            </h2>

                            <h4 className="uk-text-lead uk-text-muted uk-margin-small-top">
                                {t("infopages.landing.info_h2")}
                            </h4>

                            <p className="uk-margin-small-top">
                                {t("infopages.landing.info_p")}
                            </p>

                            <p className="uk-margin-small-top">
                                {t("infopages.landing.info_p2")}
                            </p>

                            <a
                                href="/apply-visa"
                                className="uk-button uk-button-jai uk-button-large uk-margin-top">
                                {t("infopages.landing.cta1")}
                            </a>
                        </div>

                        <div className="uk-width-1-2@s uk-visible@s"></div>
                    </div>
                </section>

                <PartnersListScroll />

                <section className="uk-section uk-section-primary">
                    <div className="uk-container">
                        <div className="uk-grid-small uk-child-width-1-5@m uk-margin-large-top" data-uk-grid>

                            {/* Employment Visa — C3 */}
                            <ArticleWithModal
                                Image="https://www.tengizchevroil.com/images/default-source/career/career/program_left.webp?sfvrsn=5b87ce5c_2"
                                ImageDescription="Professional engineers working in Kazakhstan"
                                ArticleTitle={t("infopages.visas.3.title")}
                                Paragraph1={t("infopages.visas.3.p1")}
                                Paragraph2={t("infopages.visas.3.p2")}
                                Paragraph3={t("infopages.visas.3.p3")}
                                Paragraph4={t("infopages.visas.3.p4")}
                                Paragraph5={t("infopages.visas.3.p5")}
                                modalName="modal-visa-c3"
                            />

                            {/* Student Visa — C9 */}
                            <ArticleWithModal
                                Image="https://img.the-village-kz.com/the-village.com.kz/post-image_featured/FUMzgk0pFMxkZp4qMCVVgw-double.jpg"
                                ImageDescription="International students on campus"
                                ArticleTitle={t("infopages.visas.5.title")}
                                Paragraph1={t("infopages.visas.5.p1")}
                                Paragraph2={t("infopages.visas.5.p2")}
                                Paragraph3={t("infopages.visas.5.p3")}
                                Paragraph4={t("infopages.visas.5.p4")}
                                Paragraph5={t("infopages.visas.5.p5")}
                                modalName="modal-visa-c9"
                            />

                            {/* Business and Investor Visa — C5 */}
                            <ArticleWithModal
                                Image="/imgvideo/asset1.jpg"
                                ImageDescription="Investor reviewing project documents"
                                ArticleTitle={t("infopages.visas.4.title")}
                                Paragraph1={t("infopages.visas.4.p1")}
                                Paragraph2={t("infopages.visas.4.p2")}
                                Paragraph3={t("infopages.visas.4.p3")}
                                Paragraph4={t("infopages.visas.4.p4")}
                                Paragraph5={t("infopages.visas.4.p5")}
                                modalName="modal-visa-c5"
                            />
                            
                            {/* Business Visa — B1/B2 */}
                            <ArticleWithModal
                                Image="https://www.shutterstock.com/image-photo/close-selective-focus-on-african-600nw-1983967556.jpg"
                                ImageDescription="Business visitors and technical consultants in Kazakhstan"
                                ArticleTitle={t("infopages.visas.1.title")}
                                Paragraph1={t("infopages.visas.1.p1")}
                                Paragraph2={t("infopages.visas.1.p2")}
                                Paragraph3={t("infopages.visas.1.p3")}
                                Paragraph4={t("infopages.visas.1.p4")}
                                Paragraph5={t("infopages.visas.1.p5")}
                                modalName="modal-visa-b1-b2"
                            />

                            {/* Standard Tourist Visa — B12 */}
                            <ArticleWithModal
                                Image="https://www.ahiska-gazeta.com/cms/uploads/images/DSCN6314.jpg"
                                ImageDescription="Tourists exploring Kazakhstan"
                                ArticleTitle={t("infopages.visas.2.title")}
                                Paragraph1={t("infopages.visas.2.p1")}
                                Paragraph2={t("infopages.visas.2.p2")}
                                Paragraph3={t("infopages.visas.2.p3")}
                                Paragraph4={t("infopages.visas.2.p4")}
                                Paragraph5={t("infopages.visas.2.p5")}
                                modalName="modal-visa-b12"
                            />



                        </div>
                    </div>
                </section>

                <YandexMapSection />

                <FooterSection />

            </main>
        </div>
    );
}

export default LandingPage;
